import {
  LayoutDashboard,
  Globe,
  LifeBuoy,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Match nested routes too (e.g. /services/*). */
  match?: 'exact' | 'startsWith';
}

/**
 * Primary sidebar navigation.
 * Projects and Teams are now inside the Organizations service console
 * (/services/organizations) — they are no longer top-level nav items.
 * Activity also moved into that console (org-wide audit log). Account is
 * pinned to the sidebar footer (see AppLayout) rather than the primary list.
 */
export const PRIMARY_NAV: NavItem[] = [
  { label: 'Overview', to: '/', icon: LayoutDashboard, match: 'exact' },
  { label: 'Services', to: '/services', icon: Globe, match: 'startsWith' },
  { label: 'Support', to: '/support', icon: LifeBuoy, match: 'startsWith' },
];

export function isActive(item: NavItem, pathname: string): boolean {
  if (item.match === 'startsWith') {
    return pathname === item.to || pathname.startsWith(`${item.to}/`);
  }
  return pathname === item.to;
}
